module.exports = __webpack_public_path__ + "static/0068-f4f7f2d1aacd9f7b80b9da887b1a6157.png";